/**
 * CustomerBranding
 *
 * Renders the platform logo, name, and applies brand colors.
 * Falls back to default NodeGeeks branding when platform config
 * has no branding set.
 *
 * Requirements: 3.2, 6.2, 6.4
 */

import React from 'react';
import type { PlatformBranding } from '../../types/platform.types';
import styles from './CustomerLogin.module.css';

/** Default NodeGeeks branding used when platform config has none */
export const DEFAULT_BRANDING: Required<PlatformBranding> = {
  logo: '',
  primaryColor: '#0972d3',
  name: 'NodeGeeks',
};

export interface CustomerBrandingProps {
  branding?: PlatformBranding;
}

export const CustomerBranding: React.FC<CustomerBrandingProps> = ({ branding }) => {
  const logo = branding?.logo || DEFAULT_BRANDING.logo;
  const name = branding?.name || DEFAULT_BRANDING.name;

  return (
    <div className={styles.branding}>
      {logo ? (
        <img src={logo} alt={`${name} logo`} className={styles.logo} />
      ) : (
        <span className={styles.logoFallback} aria-label={`${name} logo`}>
          {name}
        </span>
      )}
      {/* Only show the name text separately when a logo is present */}
      {logo && <span className={styles.brandName}>{name}</span>}
    </div>
  );
};

export default CustomerBranding;
